/**
 * T084: useTags Hook
 * Query hook for fetching tags list
 */

import { useQuery } from '@tanstack/react-query'
import { listTags } from '@/services/tags'
import { queryKeys } from '@/lib/query-keys'

export function useTags() {
  return useQuery({
    queryKey: queryKeys.tags.all,
    queryFn: () => listTags({ limit: 100 }),
  })
}
